import { render, staticRenderFns } from "./RelatorioProdutoFormulario.vue?vue&type=template&id=2db9fec0&scoped=true"
import script from "./RelatorioProdutoFormulario.vue?vue&type=script&lang=js"
export * from "./RelatorioProdutoFormulario.vue?vue&type=script&lang=js"
import style0 from "./RelatorioProdutoFormulario.vue?vue&type=style&index=0&id=2db9fec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db9fec0",
  null
  
)

export default component.exports